/**Formulario de ingreso de datos empresa y equipo de trabajo */
import React from 'react';
import { Button, Form, Modal, Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import { signOut, newUsers, newUserDetails } from '../../actions';
import history from '../../history';
import Alert from '../hupUtils/alert';


class FomrularioGlobal extends React.Component {

    state = {
        formError: null, open: true,
        error: null, errorEquipo: null, area: null,
        errorArea: null, empresa: null, errorEmpresa: null,
        errorSector: null, mensajeCodigo: { titulo: 'Falta campos por llenar', detalle: 'Debes diligenciar todos los campos' }

    }

    componentWillMount() {
        if (!this.props.userDetail)
            history.push('/');
    }
    continuar = () => {
    
            this.props.newUserDetails({ ...this.props.newUserDetail, tipo: 'Gestor' })
            history.push('/formulario/termcond');

    }
    close = () => this.setState({ open: false })
    cancelar = () => {
        this.props.signOutObj.signOut();
        this.close();
        this.props.signOut();
        this.props.newUsers(false);
        history.push('/');
    }

    handleSubmit(event) {
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            this.setState({ formError: true });
        }
        this.setState({ validated: true })
    }
    render() {

        return (


            <Modal show={true} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter"  >
                        Registrate en Hupity
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="show-grid">
                    <Container>
                        <Form>

                            <Form.Group controlId="ControlInput1">
                                <Form.Label>Dinos el nombre de tu empresa u organización</Form.Label>
                                <Form.Control required type="text" placeholder="Business" value={this.props.newUserDetail ? this.props.newUserDetail.business : null} onChange={e => this.props.newUserDetails({ ...this.props.newUserDetail, business: e.target.value })} />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="ControlInput2">
                                <Form.Label>De que tipo es</Form.Label>
                                <Form.Control required type="text" placeholder="Telecomunicaciones, Gestoria, Publicidad" value={this.props.newUserDetail ? this.props.newUserDetail.sector : null}
                                    onChange={e => this.props.newUserDetails({ ...this.props.newUserDetail, sector: e.target.value })} />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>

                            </Form.Group>
                            <Form.Group controlId="ControlInput3">
                                <Form.Label>Nombra a tu equipo de trabajo</Form.Label>
                                <Form.Control required type="text" placeholder="Define que nombre los representara" value={this.props.newUserDetail ? this.props.newUserDetail.team : null}
                                    onChange={e => this.props.newUserDetails({ ...this.props.newUserDetail, team: e.target.value })} />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="ControlSelect1">
                                <Form.Label>A que departamento de tu empresa pertenece tu equipo</Form.Label>
                                <Form.Control required as="select"
                                    value={this.props.newUserDetail ? this.props.newUserDetail.area : null}
                                    onChange={(e) => { this.props.newUserDetails({ ...this.props.newUserDetail, area: e.target.value }); }}
                                >
                                    <option value="Tecnología">Tecnología</option>
                                    <option value="Ventas">Ventas</option>
                                    <option value="Staff">Staff</option>
                                    <option value="Comercial">Comercial</option>
                                    <option value="RRHH">RRHH</option>

                                </Form.Control>
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                            </Form.Group>

                            <Alert error={this.state.formError} messageAlert={this.state.mensajeCodigo.detalle} headerAlert={this.state.mensajeCodigo.titulo} ></Alert>
                        </Form>

                    </Container>
                </Modal.Body>
                <Modal.Footer  >

                    <Button variant='light' onClick={() => this.cancelar()}>
                        Cancelar
                        </Button>
                    <Button

                        variant="info" style={{ background: 'purple', borderRadius: '10px' }} onClick={(e) => { this.handleSubmit(e); this.continuar(); }}

                        disabled=
                        {
                            this.props.newUserDetail && (
                                !this.props.newUserDetail.business ||
                                !this.props.newUserDetail.sector ||
                                !this.props.newUserDetail.team ||
                                !this.props.newUserDetail.area)
                        }
                    >Continuemos<i className="material-icons md-18">done_outline</i></Button>



                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        signOutObj: state.mainReducer.signOutObj,
        userDetail: state.mainReducer.userDetail,
        newUserDetail: state.mainReducer.newUserDetail,
    };
};
export default connect(mapStateToProps, { newUsers, signOut, newUserDetails })(FomrularioGlobal);